import { render, staticRenderFns } from "./StockMovementReport.vue?vue&type=template&id=0c6c2145&"
import script from "./StockMovementReport.vue?vue&type=script&lang=js&"
export * from "./StockMovementReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports